/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SessionDTO } from './SessionDTO';
import {
    SessionDTOFromJSON,
    SessionDTOFromJSONTyped,
    SessionDTOToJSON,
} from './SessionDTO';

/**
 * 
 * @export
 * @interface PurchaseResultDTO
 */
export interface PurchaseResultDTO {
    /**
     * 
     * @type {SessionDTO}
     * @memberof PurchaseResultDTO
     */
    session?: SessionDTO;
}

/**
 * Check if a given object implements the PurchaseResultDTO interface.
 */
export function instanceOfPurchaseResultDTO(value: object): value is PurchaseResultDTO {
    return true;
}

export function PurchaseResultDTOFromJSON(json: any): PurchaseResultDTO {
    return PurchaseResultDTOFromJSONTyped(json, false);
}

export function PurchaseResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'session': json['session'] == null ? undefined : SessionDTOFromJSON(json['session']),
    };
}

export function PurchaseResultDTOToJSON(value?: PurchaseResultDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'session': SessionDTOToJSON(value['session']),
    };
}

